import { isDefined, isNotDefined } from '@sgme/fp';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  downloadCSV,
  headerExport,
  mapScheduleValues,
} from '@/App/tiles/TargetAccumulator/Schedule/ScheduleHeader/utils.ts';
import {
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { isEmpty } from '@/components/sg-design-system/utils/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorAccuType } from '@/store/targetAccumulator/selectors.ts';
import { getTargetAccumulatorCalendarColumns } from '@/store/targetAccumulator/utils.ts';

const ExportSchedule = () => {
  const tileId = useTargetAccumulatorTileId();
  const { formatMessage } = useIntl();
  const accuType = useAppSelector((state) => selectTargetAccumulatorAccuType(state, tileId));
  const schedule = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.schedule);

  const scheduleColumns = getTargetAccumulatorCalendarColumns(accuType ?? 'TargetAccu').filter(
    (props) => props !== 'deleteIcon',
  );

  const headerExportElements = scheduleColumns.map((calendarItem) => formatMessage({ id: headerExport(calendarItem) }));

  const exportSchedule: React.MouseEventHandler<HTMLElement> = useCallback(
    (event) => {
      event.stopPropagation();

      const usedScheduleValues = mapScheduleValues(schedule, scheduleColumns);

      if (isNotDefined(usedScheduleValues) && isEmpty(usedScheduleValues)) {
        console.warn('No schedule data to export');
        return;
      }

      const getScheduleList = (scheduleElement?: Record<string, string | number | null>) => {
        if (isDefined(scheduleElement)) {
          return scheduleColumns.map((scheduleElementItem) => scheduleElement[scheduleElementItem]).join(';');
        }
        return [];
      };

      const output = ['sep=;', headerExportElements.join(';'), ...usedScheduleValues.map(getScheduleList)].join('\r\n');

      downloadCSV(output);
    },
    [schedule, scheduleColumns, headerExportElements],
  );

  return (
    <button type="button" className="btn btn-sm btn-link btn-text-icon me-1" onClick={exportSchedule}>
      <FormattedMessage id="accumulator.scheduler.export" />
      <i className="ms-1 icon icon-sm">save_alt</i>
    </button>
  );
};

export default ExportSchedule;
